import { ActionTypes } from './actionTypes';
import { Account } from '../types/user';

export const createUserAccount = (payload: Account) => {
  return { type: ActionTypes.CreateUserAccount, payload };
};
